"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _ = require("..");
var SPARouteMetricsProvider = function SPARouteMetricsProvider(_ref) {
  var pageId = _ref.pageId,
    pathname = _ref.pathname,
    legacyWeb = _ref.legacyWeb,
    attributes = _ref.attributes,
    GDPR = _ref.GDPR,
    user = _ref.user,
    country = _ref.country,
    children = _ref.children;
  var _GDPR$hasGDPRConsent = GDPR.hasGDPRConsent,
    hasGDPRConsent = _GDPR$hasGDPRConsent === void 0 ? false : _GDPR$hasGDPRConsent;
  var _user$id = user.id,
    userId = _user$id === void 0 ? '1' : _user$id,
    _user$package = user.package,
    packageId = _user$package === void 0 ? '1' : _user$package,
    _user$email = user.email,
    email = _user$email === void 0 ? '' : _user$email;
  var metricsData = (0, _react.useMemo)(function () {
    return {
      hasGDPRConsent: hasGDPRConsent,
      userId: userId,
      packageId: packageId,
      email: email,
      countryCode: country
    };
  }, [hasGDPRConsent, userId, packageId, email, country]);
  (0, _react.useEffect)(function () {
    // update the global config
    _.MetricsTracker.update({
      pageId: pageId,
      legacyWeb: legacyWeb
    });

    /*
    // TODO: This shouldn't fire on intital render, but it needs to right now
    // to ensure all page metrics for SPA are accurately recorded. For example
    // in the SPA, PAGE_VIEW only knows about the SPA container, not the page within
    // the container. So the VIRTUAL_PAGE_VIEW is needed to track the actual page content
    */
    _.MetricsTracker.track({
      name: _.USER_EVENTS.VIRTUAL_PAGE_VIEW,
      data: {
        actionType: _.USER_EVENTS.VIRTUAL_PAGE_VIEW,
        actionFlow: pageId,
        pageId: pageId,
        attributes: attributes,
        pathname: pathname,
        data: metricsData
      }
    });
  }, [pageId, legacyWeb, pathname, attributes, metricsData]);
  return children;
};
var _default = exports.default = SPARouteMetricsProvider;
module.exports = exports.default;
//# sourceMappingURL=SPARouteMetricsProvider.js.map